<template>
  <div style="width: 100%; heigh: 100%" id="role_conf">
    <el-card class="table-card" style="height: 830px">
      <div class="table_common_operbar" v-if="permission.btn_role_add">
        <el-row>
          <el-button icon="el-icon-plus" type="primary" size="small" @click="addWindowShow()">新增角色</el-button>
          <!-- <el-button type="primary" size="small" @click="isShow = !isShow">配置机组看板</el-button> -->
        </el-row>
      </div>
      <el-table :data="tableData" stripe style="width: 100%" class="deviceTable">
        <el-table-column prop="name" label="角色名称" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="gmtCreate" label="创建时间" :formatter="parseDate"></el-table-column>
        <el-table-column prop="gmtModified" label="修改时间" :formatter="parseModifiedDate"></el-table-column>
        <el-table-column label="操作" fixed="right" width="160">
          <template slot-scope="scope">
            <el-button type="text" v-if="permission.btn_permission_get" @click="showViewDialog(scope.row)" size="small">查看</el-button>
            <el-button type="text" v-if="permission.btn_role_update && !scope.row.isDefaultRole" @click="showEditDialog(scope.row)" size="small">编辑</el-button>
            <el-button class="btn-del" type="text" v-if="permission.btn_role_delete && !scope.row.isDefaultRole" @click="deleteConfig(scope.row)" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page" v-if="tableData.length > 0">
        <div class="total_page">
          <span> 共{{ tableTotalPage }}条 10条/页</span>
        </div>
        <div style="margin-top: 10px; text-align: right; margin-bottom: 20px">
          <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"> </el-pagination>
        </div>
      </div>
    </el-card>
    <!-- 新增开始 -->
    <el-dialog title="新增角色" @close="cancelAddDialog" :default-checked-keys="[]" :visible.sync="addDialogVisible" :width="span == 5 ? '36%' : '50%'" center :close-on-click-modal="false">
      <el-form :model="addForm" :rules="rules" ref="addForm" style="width: 100%" class="add_form">
        <el-row :gutter="20" style="margin-bottom: 0px">
          <el-col :span="10" :offset="7">
            <span class="titel">角色名称：</span>
            <el-form-item prop="name" class="value" :rules="rules.configName">
              <el-input ref="focusinput" size="small" style="max-width: 180px" v-model="addForm.name" maxlength="16" placeholder="角色名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :offset="1">
            <el-scrollbar style="width: 92%">
              <el-tree :render-content="testContent" default-expand-all @check-change="addCheckChange" ref="addTree" :data="permissionTree" show-checkbox node-key="id" :props="defaultProps">
              </el-tree>
            </el-scrollbar>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAddDialog">添 加</el-button>
        <el-button @click="cancelAddDialog">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 新增结束 -->

    <!-- 编辑开始 -->
    <el-dialog title="编辑角色" @close="cancelEditDialog" :visible.sync="editDialogVisible" :width="span == 5 ? '44%' : '50%'" center :close-on-click-modal="false">
      <el-form :model="addForm" :rules="rules" ref="editForm" style="width: 100%" class="add_form">
        <el-row :gutter="20" style="margin-bottom: 0px">
          <el-col :span="10" :offset="7">
            <span class="titel">角色名称：</span>
            <el-form-item prop="name" class="value" :rules="rules.configName">
              <el-input size="small" style="max-width: 180px" v-model="addForm.name" maxlength="16" placeholder="角色名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :offset="1">
            <el-scrollbar style="width: 92%">
              <el-tree :render-content="testContent" default-expand-all @check-change="editCheckChange" ref="editTree" :data="permissionTree" show-checkbox node-key="id" :props="defaultProps">
              </el-tree>
            </el-scrollbar>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitEditDialog">保 存</el-button>
        <el-button @click="cancelEditDialog">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 编辑结束 -->

    <!-- 查看开始 -->
    <el-dialog title="查看角色" @close="cancelViewDialog" :visible.sync="viewDialogVisible" :width="span == 5 ? '36%' : '50%'" center :close-on-click-modal="false">
      <el-form :model="addForm" :rules="rules" ref="addForm" style="width: 100%" class="add_form">
        <el-row :gutter="20" style="margin-bottom: 0px">
          <el-col :span="10" :offset="7">
            <span class="titel">角色名称：</span>
            <span>{{ addForm.name }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :offset="1">
            <el-scrollbar style="width: 92%">
              <el-tree :render-content="testContent" default-expand-all ref="viewTree" :data="permissionTree" show-checkbox node-key="id" :props="defaultProps1"> </el-tree>
            </el-scrollbar>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelViewDialog" type="primary">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看结束 -->
    <BoardConfig :isShow.sync="isShow"></BoardConfig>
  </div>
</template>

<script>
const log = console.log.bind(console);
import BoardConfig from "@/components/common/boardConfig.vue";
export default {
  name: "RoleConf",
  components: {
    BoardConfig
  },
  data() {
    return {
      isShow: false,
      fristLoad: false,
      defaultProps: {
        children: "sonList",
        label: "name"
      },
      defaultProps1: {
        children: "sonList",
        label: "name"
      },
      // writeList:[3,6,9,14,16,19,22,25],
      // readList:[2,5,8,13,15,18,21,24],

      selectId: null,
      disabled: false,
      selectIdList: [],
      permissionIdListOld: [],
      permissionIdListCopy: [],
      permissionIdList: [],
      permissionTree: [],
      W: false,
      btnPressType: 0, //按钮类型： 0-默认 1-查询 2-重置 3-分页
      searchFormTemp: "", //临时搜索数据
      searchForm: {
        workingLevel: null,
        configName: ""
      },
      addForm: {
        name: ""
      },
      tableData: [],
      tableCurrentPage: 1,
      tableTotalPage: 2,
      addDialogVisible: false,
      editDialogVisible: false,
      viewDialogVisible: false,
      data: {
        token: localStorage.getItem("token")
      },
      rules: {
        configName: [{ required: true, message: "请输入角色名称", trigger: "blur" }]
      },
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },
  mounted: function() {
    this.initTable();
    this.loadpermissionList();
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
  },
  computed: {
    span() {
      return this.W ? 5 : 7;
    }
  },
  deactivated: function() {
    console.log("deactivated");
  },
  methods: {
    addCheckChange(data, checked) {
      // if(data.parentId!=-1){
      //     if(data.type){
      //        let checkList = this.$refs.addTree.getCheckedKeys()
      //        //1.type=R 查找兄弟节点
      //        if(data.type=='R'&&!checked){
      //            let brotherList= this.getsonListById(data,data.type)
      //            brotherList.forEach(item=>{
      //                let brotherSelect = checkList.includes(item.id)
      //                if(brotherSelect){
      //                    this.$refs.addTree.setChecked(item.id,false)
      //                }
      //            })
      //        }
      //        //当类型为写并且选择，把兄弟节点设置为选中
      //        if(data.type=='W'&&checked){
      //            this.$refs.addTree.setChecked(data.brotherId,true)
      //        }
      //     }
      // }
    },
    getsonListById(data, type) {
      let arr = [];
      this.permissionTree.forEach(item => {
        if (item.id == data.parentId) {
          if (type == "R") {
            arr = item.sonList.filter(s => s.type == "W" && s.brotherId == data.id);
          }
        }
      });
      return arr;
    },
    editCheckChange(data, checked) {
      // if(data.parentId!=-1){
      //     if(data.type){
      //         let checkList = this.$refs.editTree.getCheckedKeys()
      //         //1.type=R 查找兄弟节点
      //         if(data.type=='R'&&!checked){
      //            let brotherList= this.getsonListById(data,data.type)
      //            brotherList.forEach(item=>{
      //                let brotherSelect = checkList.includes(item.id)
      //                if(brotherSelect){
      //                    this.$refs.editTree.setChecked(item.id,false)
      //                }
      //            })
      //         }
      //         //当类型为写并且选择，把兄弟节点设置为选中
      //         if(data.type=='W'&&checked){
      //            this.$refs.editTree.setChecked(data.brotherId,true)
      //         }
      //     }
      // }
    },
    handleCheckAllChange(val, index) {
      this.$set(this.permissionTree[index], "select", val);
      if (val) {
        this.$set(this.permissionIdList, index, commonUtils.cloneObj(this.permissionIdListCopy[index]));
      } else {
        this.$set(this.permissionIdList, index, []);
      }
      log(this.permissionIdList);
    },
    handleCheckedCitiesChange(value, index) {
      if (value.length > 0) {
        this.$set(this.permissionTree[index], "select", true);
      } else {
        this.$set(this.permissionTree[index], "select", false);
      }
      this.permissionTree = JSON.parse(JSON.stringify(this.permissionTree));
    },
    loadpermissionList() {
      this.$RequestUtil.get({
        url: "/api/permission/listPermission",
        type: "sync",
        params: {},
        success: res => {
          this.permissionTree = res.data;
          res.data.forEach(item => {
            // if(item.name=='生产管理'){  //临时隐藏甘特图权限
            //     item.sonList = item.sonList.filter(sub=>sub.name!='订单视图'&&sub.name!='工人负荷'&&sub.name!='设备负荷')
            // }
            let arr = [];
            item.select = false;
            item.sonList.forEach(s => {
              arr.push(s.id);
            });
            this.permissionIdList.push(arr);
          });
          this.permissionIdListCopy = commonUtils.cloneObj(this.permissionIdList);
          this.permissionIdList.forEach(item => {
            item.length = 0;
          });
          this.permissionIdListOld = commonUtils.cloneObj(this.permissionIdList);
        }
      });
    },
    deleteConfig(rowData) {
      this.$confirm("此操作将删除该角色, 删除后不可撤销，是否继续?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$RequestUtil.get({
          url: "/api/role/deleteRole",
          type: "sync",
          params: {
            roleId: rowData.id
          },
          success: res => {
            if (res.code != -1) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.search(1);
            } else {
              this.$message.error(res.msg || res.message);
            }
          }
        });
      });
    },
    cancelEditDialog() {
      this.editDialogVisible = false;
      this.addForm = {
        name: ""
      };

      this.permissionIdList = commonUtils.cloneObj(this.permissionIdListOld);
      this.permissionTree.forEach(item => {
        item.select = false;
      });
    },
    cancelViewDialog() {
      this.viewDialogVisible = false;
      this.addForm = {
        name: ""
      };
      this.permissionIdList = commonUtils.cloneObj(this.permissionIdListOld);

      this.permissionTree.forEach(item => {
        item.select = false;
        item.disabled = false;
        item.sonList.forEach(s => {
          s.disabled = false;
          s.select = false;
          if (s.sonList) {
            s.sonList.forEach(sub => {
              sub.disabled = false;
              sub.select = false;
            });
          }
        });
      });
    },
    removeDetail(rowIndex) {
      this.addForm.detailList.splice(rowIndex, 1);
    },

    cancelAddDialog() {
      this.addForm = {
        name: ""
      };
      this.$refs.addTree.setCheckedKeys([]);
      this.addDialogVisible = false;
    },
    submitAddDialog() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          let checkList = this.$refs.addTree.getCheckedKeys();
          this.permissionTree.forEach(item => {
            item.sonList.forEach(s => {
              if (checkList.includes(s.id) && !checkList.includes(item.id)) {
                checkList.push(item.id);
              }
            });
          });
          this.$RequestUtil.post({
            url: "/api/role/addRole",
            type: "sync",
            params: {
              name: this.addForm.name,
              permissionIdList: checkList.sort()
            },
            success: res => {
              if (res.code == 0) {
                this.$message.success("添加成功");
                this.addDialogVisible = false;
                this.initTable();
                this.cancelAddDialog();
              } else {
                this.$message.error(res.message);
              }
            }
          });
        }
      });
    },
    submitEditDialog() {
      this.$refs["editForm"].validate(valid => {
        if (valid) {
          let checkList = this.$refs.editTree.getCheckedKeys();
          this.permissionTree.forEach(item => {
            item.sonList.forEach(s => {
              if (checkList.includes(s.id) && !checkList.includes(item.id)) {
                checkList.push(item.id);
              }
              s.sonList.forEach(ss => {
                if (checkList.includes(ss.id) && !checkList.includes(s.id)) {
                  checkList.push(s.id);
                }
              });
            });
          });
          this.$RequestUtil.post({
            url: "/api/role/updateRole",
            type: "sync",
            params: {
              name: this.addForm.name,
              permissionIdList: checkList.sort(),
              id: this.selectId
            },
            success: res => {
              if (res.code == 0) {
                this.$message.success("编辑成功");
                this.editDialogVisible = false;
                this.initTable();
                this.cancelEditDialog();
              } else {
                this.$message.error(res.message);
              }
            }
          });
        }
      });
    },
    btnSearch: function() {
      this.tableCurrentPage = 1;
      this.btnPressType = 1;
      this.search();
    },
    clearSearch() {
      let form = this.searchForm;
      this.btnPressType = 2;
      form.configName = "";
      form.workingLevel = null;
    },
    search: function() {
      let temp;
      switch (this.btnPressType) {
        case 1:
          temp = commonUtils.cloneObj(this.searchForm);
          this.searchFormTemp = commonUtils.cloneObj(temp);
          break;
        case 0:
          temp = {
            configName: "",
            workingLevel: ""
          };
          break;
        case 2:
          temp = this.searchFormTemp;
          break;
        case 3:
          temp = this.searchFormTemp;
          break;
      }
      this.$RequestUtil.get({
        url: "/api/role/listRole",
        type: "sync",
        params: {
          pageNum: this.tableCurrentPage,
          pageSize: 10,
          configName: temp.configName,
          workingLevel: temp.workingLevel
        },
        success: res => {
          if (res.msg == this.$Global.RESPONSE.SUCCESS) {
            this.tableData = res.data;
            this.tableTotalPage = res.totalPages;
            if (res.totalPages == 0 && this.fristLoad) {
              this.$message.warning("查询不到符合条件的数据");
            }
            this.fristLoad = true;
          } else {
            this.$message.error(res.message || res.msg);
          }
        }
      });
    },
    pageChange: function(targetPage) {
      this.tableCurrentPage = targetPage;
      this.btnPressType = 3;
      this.search();
    },
    initTable: function() {
      this.search();
    },
    addWindowShow: function() {
      this.addDialogVisible = true;
      setTimeout(() => {
        this.$refs.focusinput.focus();
        this.$refs.addTree.setCheckedKeys([]);
      }, 0);
    },
    parsePermission(rowData, type) {
      let arr = [];
      let splitList = [];
      this.permissionTree.forEach(item => {
        let index = rowData.permissionIdList.indexOf(item.id);
        if (index > -1) {
          item.select = true;
          arr.push(index);
          splitList.push(index);
        } else {
          item.select = false;
          arr.push([]);
        }
      });
      splitList.forEach((item, i) => {
        let next = splitList[i + 1];
        let splitArr = [];
        if (!next) {
          splitArr = rowData.permissionIdList.slice(item + 1);
        } else {
          splitArr = rowData.permissionIdList.slice(item + 1, next);
        }
        let index = arr.indexOf(item);
        if (index > -1) {
          arr[index] = splitArr;
        }
      });
      return arr;
    },
    showEditDialog: function(rowData) {
      this.selectId = rowData.id;
      this.editDialogVisible = true;
      this.addForm.name = rowData.name;
      if (!rowData.permissionIdList) {
        rowData.permissionIdList = [];
      }
      let checkList = commonUtils.cloneObj(rowData.permissionIdList);
      setTimeout(() => {
        this.permissionTree.forEach(item => {
          let index = checkList.indexOf(item.id);
          if (index > -1) {
            checkList.splice(index, 1);
          }
          item.disabled = false;
          item.sonList.forEach(s => {
            let indexs = checkList.indexOf(s.id);
            if (indexs > -1 && s.sonList.length) {
              checkList.splice(indexs, 1);
            }
            s.disabled = false;
            if (s.sonList) {
              s.sonList.forEach(sub => {
                sub.disabled = false;
              });
            }
          });
        });
        this.$refs.editTree.setCheckedKeys(checkList);
      }, 0);
    },
    showViewDialog(rowData) {
      this.viewDialogVisible = true;
      this.addForm.name = rowData.name;
      let checkList = commonUtils.cloneObj(rowData.permissionIdList);
      setTimeout(() => {
        this.permissionTree.forEach(item => {
          let index = checkList.indexOf(item.id);
          if (index > -1) {
            checkList.splice(index, 1);
          }
          this.$refs.viewTree.setCheckedKeys(checkList);
          item.disabled = true;
          item.sonList.forEach(s => {
            s.disabled = true;
            if (s.sonList) {
              s.sonList.forEach(sub => {
                sub.disabled = true;
              });
            }
          });
        });
        // this.permissionTree = JSON.parse(JSON.stringify(this.permissionTree))
      }, 0);
    },
    viewDevice: function(rowData) {
      this.viewDialogVisible = true;
    },
    parseDate: function(rowData) {
      if (rowData.gmtCreate != null) {
        let dateString = commonUtils.timestampToDate(rowData.gmtCreate, true);
        return dateString;
      }
    },
    parseModifiedDate: function(rowData) {
      if (rowData.gmtModified != null) {
        let dateString = commonUtils.timestampToDate(rowData.gmtModified, true);
        return dateString;
      }
    },
    testContent(h, { node, data, store }) {
      let html = null;
      let styleJson = {};
      if (data.hierarchy == 1) {
        styleJson = {
          fontSize: "18px",
          color: "#333"
          // marginTop:'12px'
        };
      } else if (data.hierarchy == 2) {
        styleJson = {
          fontSize: "16px",
          // marginTop:'8px',
          display: "inline-block",
          width: "400px",
          color: "#303133"
        };
      } else if (data.hierarchy == 3) {
        styleJson = {
          fontSize: "14px"
          // marginTop:'4px',
        };
      }
      html = <span style={styleJson}>{data.name}</span>;
      return html;
    }
  }
};
</script>

<style scoped>
#role_conf /deep/ .el-tree-node.is-expanded > .el-tree-node__children {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}
/* #role_conf /deep/ .el-tree-node__children>.el-tree-node {
    margin-top: 8px;
} */
#role_conf /deep/ .tree > .treeitem {
  width: 100%;
}
#role_conf /deep/ .el-tree-node__content:hover {
  background-color: transparent;
}
#role_conf /deep/ .el-tree-node:focus > .el-tree-node__content {
  background-color: transparent;
}
.delete {
  width: 18px;
  height: 19px;
  background-image: url("../../../static/img/del.png");
  cursor: pointer;
  background-repeat: no-repeat;
}
.delete:hover {
  background-image: url("../../../static/img/del-hover.png");
  background-repeat: no-repeat;
}
.table_searchbar .title11 {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
}
.add_form .title {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
  display: inline-block;
  text-align: right;
  width: 70px;
}
.add_form .value {
  display: inline-block;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.table_searchbar {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 20px;
}
.import_upload {
  display: inline;
}
.page {
  display: flex;
  justify-content: flex-end;
}
@media screen and (max-width: 1380px) {
  .page {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}
.total_page {
  margin-top: 20px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}
</style>
<style>
#chechConf .el-form-item--mini.el-form-item,
#chechConf .el-form-item--small.el-form-item {
  margin-top: 8px;
  margin-bottom: 13px;
}
.table_searchbar .el-button--mini,
.el-button--mini.is-round {
  padding: 7px 10px;
}
.el-textarea .el-input__count {
  line-height: 12px;
}

#role_conf .el-scrollbar__wrap {
  overflow-x: hidden;
  height: 440px;
  overflow-x: hidden;
  margin-bottom: 0px !important;
}
#role_conf .el-tree-node__content {
  width: 100%;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Role/RoleConf.vue